/**
 * 通知管理组件
 */

import {
    Style
} from '@/libs/style.js';

let template = /*html*/ `<div class="app-notification">
<div class="app-notification-header">
    <img src="./images/default/2.png" alt="">
    <h4>通知管理</h4>
</div>
<el-tabs v-model="activeName" @tab-click="handleClick" class="tab-section" :stretch="true">
    <el-tab-pane class="tab-item" label="故障" name="malfunction">故障</el-tab-pane>
    <el-tab-pane class="tab-item" label="通知" name="notification">通知</el-tab-pane>
    <el-tab-pane class="tab-item" label="报警" name="warn">报警</el-tab-pane>
  </el-tabs>
</div>`;


let style = /* css */ `.app-notification{
    position: absolute;
    top: calc(560px + 100px);
    left: 1%;
    width: 25%;
    background: rgba(0,0,0,0.2);
    height: 270px;
    overflow: hidden;
}

.app-notification .app-notification-header{
    background:linear-gradient(to right,#67BDFF,rgba(0,0,0,0) 50%);
    height: 50px;
    color: #fff;
    display:flex;
    align-items:center;
}
.app-notification .app-notification-header img{
    margin:0 15px;
}

.app-notification .tab-section{
    padding:0 20px;
    color:#fff;
}
.app-notification .tab-item{
    color:#fff;
}
.app-notification .el-tabs__item{
    color:#fff;
}
`;

export default (Vue) => {
    Vue.customElement('app-notification', {
        template: template,
        data() {
            return {
                activeName: 'malfunction'
            }
        },
        mounted() {
            Style(style);
        },
        methods: {
            handleClick(tab, event) {
                console.log(tab, event);
            }
        }
    });
}